import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonAiGenerateSrf(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const onClick = () => map.commands.aiGenerateSrf(map.selectedNodes)

    return filterByLicense('M00040001',
        <MenuButton
            onClick={onClick}
            {...props}
        >
            AI分析需求变更
        </MenuButton>
    )
}
